import toDate from '../toDate';

export default function formatCalendarDate(value) {
  const date = toDate(value);
  if (!date) return null;

  return date
    .toISOString()
    .replace(/-/gm, '')
    .replace(/:/gm, '')
    .replace(/\.\d{3}/, '');
}
